jQuery( function ($) {

    
    // improved gform ajax spinner
    $(document).on( 'submit', '.gform_wrapper form', function () {
        let $button = $( 'button[type=submit]', this );
        if ( !$button.length ) { return; }
        $button.attr( 'disabled', true );
        $button.attr( 'aria-disabled', 'true' );
        $button.addClass( 'is-ajax-submitting' );
    });


    function init_select2 ( element ) {
        let $element = $(element);
        let $gf_placeholder = $( 'option.gf_placeholder', $element );
        if ( $gf_placeholder.length ) {
            $element.attr( 'data-placeholder', $gf_placeholder.text() );
            $gf_placeholder.html('').removeClass( 'gf_placeholder' );
        }
        $element.select2({
            minimumResultsForSearch: 8,
            closeOnSelect: $(element).data().close_on_select ?? true,
            allowClear: $element.attr( 'aria-required' ) != 'true',
        });
        $( '+ .select2 .select2-selection__arrow', $element ).append( `<span class='icon fas fa-chevron-down'></span>` );
    }


    $( 'select' ).each( function () {
        init_select2( this );
    });


    // mask dates
    function init_datepicker ( element ) {
      const $element = $(element);
      if ( $element.attr( 'placeholder' ) == 'dd/mm/yyyy' ) {
        $element.mask( '99/99/9999' );
      }
    }
    $( '.gform_wrapper input.datepicker' ).each( function () {
      init_datepicker( this );
    });


    $(document).on( 'gform_post_render', function ( e, form_id, current_page ) {
        $( 'select', `#gform_${ form_id }` ).each( function () {
            init_select2( this );
        });
        $( 'input.datepicker', this ).each( function () {
          init_datepicker( this );
        });
        nest_gform_fields( form_id );
        jQuery( 'input, textarea', '.gform-readonly' ).attr( 'readonly', true );
    });
    

    function nest_gform_fields ( form_id ) {
        if( ! window.gf_form_conditional_logic ) {
            return;
        }
        const $form = $( `form#gform_${ form_id }`);
        const conditional_logic = rgars( gf_form_conditional_logic, [ form_id, 'logic' ].join( '/' ) );
        if ( !conditional_logic ) { return; }
        Object.entries( conditional_logic ).forEach( entry => {
            const [ field_id, logic ] = entry;
            if ( logic.field ) {
                const $dependent_field = $( `#field_${ form_id }_${ field_id }` );
                if ( $dependent_field.length && $dependent_field.hasClass( 'nest_in_gchoice' ) ) {
                    logic.field.rules.forEach( rule => {
                        const $gchoice_input = $( `#field_${ form_id }_${ rule.fieldId } .gfield-choice-input[value='${ rule.value }']` );
                        if ( $gchoice_input.length ) {
                            $gchoice_input.closest( '.gchoice' ).append( $dependent_field );
                        }
                    });
                }
            }
        });
    }
    setTimeout( function () {
        $( `form[id^=gform_]` ).each( function () {
            nest_gform_fields( this.id.replace( 'gform_', '' ) );
        });
    }, 1 );


    // scroll up if necessary
    // on multipage form change
    $( document ).on( 'gform_page_loaded', function ( e, form_id ) {
        ThemeJS.Functions.maybe_scroll_up( $( `form#gform_${ form_id } .gform_body` ) );
    });
    // on successful submission
    $( document ).on( 'gform_confirmation_loaded', function ( e, form_id ) {
        ThemeJS.Functions.maybe_scroll_up( $( `#gform_confirmation_wrapper_${ form_id }` ) );
    });

});